import React from "react";
import ReactDOM from "react-dom";
import { Catalog, pageLoader } from "catalog";
import css from "./styles/styles.css";

const pages = [
  {
    path: "/",
    title: "Introduction",
    content: pageLoader(() => import("./pages/intro.md")),
  },
  // {
  //   title: "Concept Design",
  //   pages: [
  //     {
  //       path: "/conceptdesign",
  //       hideFromMenu: true,
  //       title: "Concept Design",
  //       content: require("./pages/conceptdesign.md"),
  //     },
  //   ],
  // },
  {
    title: "Style",
    pages: [
      {
        path: "/colors",
        title: "Colors",
        content: require("./pages/colors.md"),
      },
      {
        path: "/type",
        title: "Typography",
        content: require("./pages/type.md"),
      },
      {
        path: "/assets",
        title: "Art",
        content: require("./pages/assets.md"),
      },
    ],
  },
  {
    title: "Modules",
    pages: [
      {
        path: "/structure",
        title: "Structure",
        content: require("./pages/structure.md"),
      },
      {
        path: "/modules",
        title: "Assignments",
        content: require("./pages/modules.md"),
      },
      {
        path: "/designquestions",
        title: "Design Questions",
        content: require("./pages/designquestions.md"),
      }
    ],
  },
  {
    title: "User Interface",
    pages: [
      {
        path: "/navigation",
        title: "Navigation",
        content: require("./pages/navigation.md"),
      },
      {
        path: "/toggle",
        title: "Toggle",
        content: require("./pages/toggle.md"),
      }
    ],
  },
];

ReactDOM.render(
  <Catalog
    title="General Forecast Styleguide"
    logoSrc="/2020logo.png"
    theme={{
      background: "#fdfdfd",
      brandColor: "#222222",
      linkColor: "#008FD7",
      pageHeadingBackground: "#f5f5f5",
      pageHeadingTextColor: "#222222",
      sidebarColorHeading: "#ff7400",
      sidebarColorText: "#777",
      sidebarColorTextActive: "#222222",
      navBarTextColor: "#008FD7",
    }}
    styles={css}
    pages={pages}
  />,
  document.getElementById("catalog")
);



// WEBPACK FOOTER //
// ./catalog/index.js